import React, { Component } from "react";
import correo from '../../assets/images/correo.png';
import insta from '../../assets/images/insta.png';
import tel from '../../assets/images/tel.png';
import whats from '../../assets/images/whats.png';

import './Footer.css';
import {
    MDBRow,
    MDBCol
} from "mdbreact";

class Footer extends Component {
    render() {
        return (
            <footer className="footer">
                <div className="container">
                    <MDBCol lg="12" md="12" sm="12" xs="12" xl="12" className="lineaOrange">
                    </MDBCol>
                    <br/>
                    <h2 className="futuraBold">INFÓRMATE</h2>
                    <br/>
                    <MDBRow>
                        <MDBCol size="12" sm="12" md="6" lg="3" xl="3" className="lineaBorde itemFooter">
                            <a href="mailto:contactcenter@ufg.edu.sv" target="_blank" rel="noopener noreferrer">
                                <img src={correo} className="iconoFooter" /> contactcenter@ufg.edu.sv
                            </a>
                        </MDBCol>
                        <MDBCol size="12" sm="12" md="6" lg="3" xl="3" className="lineaBorde itemFooter">
                            <a href="https://instagram.com/ufg.oficial" target="_blank" rel="noopener noreferrer">
                                <img src={insta} className="iconoFooter" /> ufg.oficial
                            </a>
                        </MDBCol>
                        <MDBCol size="12" sm="12" md="6" lg="3" xl="3" className="lineaBorde itemFooter">
                            <a href="tel:2209-2834">
                                <img src={tel} className="iconoFooter" /> 2209-2834
                            </a>
                        </MDBCol>
                        <MDBCol size="12" sm="12" md="6" lg="3" xl="3" className="itemFooter">
                            <a href="https://wa.me/22092834" target="_blank" rel="noopener noreferrer">
                                <img src={whats} className="iconoFooter" /> 2209-2834
                            </a>
                        </MDBCol>
                    </MDBRow>
                </div>
                <br/>
            </footer>
        );
    }
}
export default Footer;